/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FC, ReactNode } from 'react';
import { Button, Heading } from '@zillow/constellation-10';
import { ZillowHomeLoansURL } from 'src/utils/ZillowHomeLoansURL';
import { ContentWrapper } from './components/ContentWrapper';
import { ContentWidthControl } from './components/ContentWidthControl';
import { CatWrapper } from './components/CatWrapper';
import { StyledErrorPage } from './components/StyledErrorPage';
import { AsyncCat } from './components/AsyncCat';
import { StairsBackgroundSVG } from './components/StairsBackgroundSVG';

export const ErrorPage: FC<{
    homePageText?: ReactNode;
    homePageURL?: string;
    headingText: ReactNode;
    subHeadingText: ReactNode;
    additionalContent?: ReactNode;
}> = ({
    homePageText = 'Return to Zillow Home Loans',
    homePageURL = '/homeloans',
    headingText,
    subHeadingText,
    additionalContent,
}) => (
    <StyledErrorPage>
        <StairsBackgroundSVG />
        <ContentWrapper>
            <ContentWidthControl>
                <Heading level={4}>{headingText}</Heading>
                <Heading level={6} css={{ marginTop: 'sm' }}>
                    {subHeadingText}
                </Heading>
                <br />
                {homePageText && (
                    <Button
                        emphasis="filled"
                        css={{ marginTop: 'sm' }}
                        onClick={() => window.location.replace(new ZillowHomeLoansURL(homePageURL).resolvedURL)}>
                        {homePageText}
                    </Button>
                )}
                {additionalContent}
            </ContentWidthControl>
        </ContentWrapper>
        <CatWrapper>
            <AsyncCat />
        </CatWrapper>
    </StyledErrorPage>
);
